import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/collections/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import EnvironmentSelect from '../../common/formElements/EnvironmentSelect';
import UploadCollectionDump from './dump/UploadCollectionDump';
import ParentDocCard from '../common/ParentDocCard';
import { drapcodeIcon, drapcodeImgIcon } from '../../common/custom/icon-library';
import CollectionHeaderNav from './CollectionHeaderNav';
export class ImportCollectionDump extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  handlecancel = () => {
    const { history } = this.props;
    const { match, location } = this.props;
    const { params } = match;
    const { search } = location;
    const urlParams = new URLSearchParams(search);
    const collectionTitle = urlParams.get('collectionName').toLowerCase();
    const { projectId, collectionId, version } = this.props.match.params;

    history.push(
      `/2.0/collections/${version}/v/${projectId}/items/${collectionId}/name/${collectionTitle}`,
    );
  };
  renderUploadCollectionDump() {
    const { match, collections } = this.props;
    const { projectId, collectionId, version } = match.params;
    const { selectedCollection } = collections;
    return (
      <div>
        <CollectionHeaderNav
          label="DB_DUMP"
          projectId={projectId}
          version={version}
          selectedCollection={selectedCollection}
          uploadHeaders
        />
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            <div className="card">
              <div
                className="card-header card-header-icon"
                data-background-color="drapcode-dark-blue"
              >
                <i className={`wb ${drapcodeIcon('dbExport')}`}></i>
              </div>
              <div className="card-title-header pt-3 d-flex justify-content-evenly">
                <div>
                  {' '}
                  <h4 className="card-title">Import Data Dump</h4>
                </div>
                <div className="col-7"> </div>

                <div className="col-3 mt-8">
                  <EnvironmentSelect
                    actions={this.props.actions}
                    projectId={projectId}
                    version={version}
                  />
                </div>
              </div>
              <div className="row mx-auto">
                <div className="col-12">
                  <div className="row mx-auto">
                    <div className="offset-md-0 col-12">
                      <UploadCollectionDump
                        projectId={projectId}
                        collectionId={collectionId}
                        version={version}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer text-center  flex-start mt-4 pt-4">
                <button className="btn btn-outline btn-md " onClick={this.handlecancel}>
                  <i className="wb webconnect-times"> </i> Cancel
                </button>
              </div>
            </div>
          </div>
          <ParentDocCard>
            <h5>
              <b>About CSV Data </b>
            </h5>
            <p>
              A comma-separated values CSV file is a delimited text file that uses a comma to
              separate values. Each line of the file is a data record. Each record consists of one
              or more fields, separated by commas. The use of the comma as a field separator is the
              source of the name for this file format. A CSV file typically stores tabular data
              (numbers and text) in plain text, in which case each line will have the same number of
              fields.
            </p>
          </ParentDocCard>
        </div>
      </div>
    );
  }

  render() {
    const { history } = this.props;
    const { match, location } = this.props;
    const { params } = match;
    const { search } = location;
    const urlParams = new URLSearchParams(search);
    const collectionName = urlParams.get('collectionName');
    const { projectId, collectionId, version } = this.props.match.params;

    return (
      <div className="main">
        <div className="section">
          <div className="container">{this.renderUploadCollectionDump()}</div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportCollectionDump);
